module.exports = __webpack_public_path__ + "img/map4.24ff81f8.jpg";